import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import numeral from "numeral";

const style = {
  boxLabel: {
    display: "inline-block",
    marginTop: 16,
    marginLeft: 59
  },
  label: {
    height: 28,
    width: 177,
    color: "#0E283D",
    fontFamily: "Fira Sans",
    fontSize: 16,
    fontWeight: 600
  },
  trDevice: {
    display: "flex"
  },
  textPriceRollout: {
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 13,
    marginLeft: 65
  },
  textPrice: {
    extend: "textPriceRollout",
    fontSize: 20,
    fontWeight: 600,
    textAlign: "right",
    marginLeft: 109,
    width: 110
  },
  labelPrice: {
    color: "#A7A8A8",
    fontFamily: "Fira Sans",
    fontSize: 14,
    fontWeight: 400,
    display: "block"
  },
  boxEstimate: {
    borderTop: "1px solid #F2F2F2"
  }
};

const EstimatePrice = ({ classes, rollout, rolloutPrice, transferPrice }) => {
  let rolloutEstimate = rolloutPrice + transferPrice;
  let perRollout = rolloutEstimate / rollout;
  perRollout = rollout > 0 ? perRollout : 0.0;
  rolloutEstimate = numeral(rolloutEstimate).format("$0,0.00");
  perRollout = numeral(perRollout).format("$0,0.00");

  return (
    <div className={classes.boxEstimate}>
      <table className={classes.boxLabel}>
        <tbody>
          <tr className={classes.trDevice}>
            <td className={classes.label}>Rollout billing estimate</td>
            <td className={classes.textPrice}>
              {rolloutEstimate}
              <span className={classes.labelPrice}>total rollout cost</span>
            </td>
            <td className={classes.textPriceRollout}>
              {perRollout}
              <span className={classes.labelPrice}>per rollout</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

EstimatePrice.propTypes = {
  classes: PropTypes.object.isRequired,
  rollout: PropTypes.number.isRequired,
  rolloutPrice: PropTypes.number.isRequired,
  transferPrice: PropTypes.number.isRequired
};

export default injectSheet(style)(EstimatePrice);
